import * as React from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Provider, Flex, Button, Text, Card } from "@fluentui/react-northstar";
import { app } from "@microsoft/teams-js";
import { useState, useEffect, createContext } from "react";
import { useTeams } from "msteams-react-base-component";
import Slider from "./common/slider";
import SearchBar from "./search/search";
import { AppCtx, AppContextInterface } from "./common/context";
import {
  savePromotionId,
  setAllPromotion,
  getAllPromotionsList,
  savesingleUserPoints,
  checkBoxSelectionforRecipient,
  setPointsforEachUser,
  addPointsForCustomUser,
  getLoggedInUserDetails
} from "../action/actionCreators";
import * as promotionService from "../services/promotion.service";
import _ from "lodash";
import { LoaderExample } from "./common/loader";
import { refreshTokenGenerator } from "../services/auth.service";
import { useTranslation } from "react-i18next";
import { getUserDetails } from "../services/userDetails.service";
/**
 * Implementation of the Recognize configuration page
 */

export const PromotionComponent = () => {
  const history = useHistory();
  const [{ inTeams, theme }] = useTeams();
  const params = useParams();
  const [email, setEmail] = useState<string>();
  const [token, setToken] = useState<any>(null);
  const [promotions, setPromotion] = useState<any>({
    eligibleRecognitionPromotions: [],
  });
  const dispatch = useDispatch();
  const promotionList = useSelector(
    (state: any) => state.commonReducer.PromotionList
  );
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (localStorage.getItem("token")) {
      setToken(localStorage.getItem("token"));
    }
    // tslint:disable: no-shadowed-variable
    const token = localStorage.getItem("appToken");
    // if you want to translate to other lanaguage use the below commended one.
    const language = localStorage.getItem("lang");
    if (language) {
      i18n.changeLanguage(language);
    }
    if (token) {
      const id = document.getElementById("app");
      if (id !== null) {
        id.classList.remove("loginwrapper");
        id.classList.remove("bit-light-gray-1");
      }
    }
    if (inTeams === true) {
      app.notifySuccess();
    }
  }, [inTeams]);

  useEffect(() => {
    // console.log('Setting the Token When calling the promo page..');
    setToken(params.token);
    localStorage.setItem("appToken", params.token);
    localStorage.setItem("host", params.host);
    localStorage.setItem("context", params.context);
  }, [params && params.token]);

  React.useEffect(() => {
    const getPromotions = async () => {
      const appToken = localStorage.getItem("appToken");
      const result = await promotionService.getPromotions(appToken);

      if (result.status === 403 || result.status === 412) {
        refreshToken(appToken);
      } else {
        setPromotion(result.data);
        dispatch(getAllPromotionsList(result.data));
      }
    };
    if (
      localStorage.getItem("host") !== null ||
      localStorage.getItem("context") !== null
    ) {
      getPromotions();
    } else {
      history.push("/?botlogin");
    }
  }, [setPromotion]);
  // tslint:disable: no-shadowed-variable
  const refreshToken = async (token) => {
    const tokenResponse = await refreshTokenGenerator(token);
    if (tokenResponse.status === 200) {
      localStorage.setItem("appToken", tokenResponse.data.token);
      const result = await promotionService.getPromotions(
        tokenResponse.data.token
      );
      setPromotion(result.data);
      dispatch(getAllPromotionsList(result.data));
    }
  };

  const getLastSent = (totalSent, lastSent) => {
    let info = `${totalSent} ${t(`Promotions.Send`)} - `;
    if (lastSent === -1) {
      info = info + `${t(`Promotions.LastSent`)}: ${t(`Promotions.NA`)}`;
    } else {
      const date = new Date();
      date.setDate(date.getDate() + -1 * lastSent);
      info =
        info +
        `${t(`Promotions.LastSent`)}: ${date.getMonth() + 1
        }/${date.getDate()}/${date.getFullYear()}`;
    }

    return info;
  };

  const getRemainingPoints = (points) => {
    return `${points} ${t(`Promotions.PointsRemaining`)}`;
  };

  const getRemainingDays = (days) => {
    if (days >= 0) {
      return `${days} ${t(`Promotions.Days`)}`;
    } else {
      return `${t(`Promotions.NoEndDate`)}`;
    }
  };

  const RedirectoSearchPage = async (id, budgetInfo, promotion) => {
    const data = await getUserDetails();
    dispatch(getLoggedInUserDetails(data.data));
    dispatch(savePromotionId(promotion));
    dispatch(savesingleUserPoints({}));
    dispatch(setPointsforEachUser([]));
    dispatch(addPointsForCustomUser({}));
    dispatch(checkBoxSelectionforRecipient(false));
    // dispatch(setAllPromotion(promotion));
    history.push({
      pathname: "/search/:token",
    });
  };

  const sampleAppContext: AppContextInterface = {
    token: params,
    behaviour: promotions,
  };

  return _.size(promotionList) > 0 ? (
    <AppCtx.Provider value={sampleAppContext}>
      <Provider theme={theme} className="promoProvider appProvider">
        <Flex fill={true} column className="promoAppWrapper">
          <Text
            className="bit_text_20 bit_text_bold promoHeader"
            content={t("Promotions.Chooseprogram")}
          />
          {_.size(promotionList) > 0 &&
            promotionList.eligibleRecognitionPromotions.map((promotion) => (
              <Card
                horizontal
                aria-roledescription="card with a preview image, text and action buttons"
                className="promoCardWrapper"
              >
                <Card.Column className="promoCard">
                  <Card.Header>
                    <Text
                      content={promotion.name}
                      className="bit_text_18 bit_text_weight6k"
                    />
                    {!promotion.awardAvailable && (
                      <Text
                        className="bit_text_12 bit_tinyText"
                        content={getLastSent(
                          promotion.totalSent,
                          promotion.lastSent
                        )}
                      />
                    )}
                  </Card.Header>
                  <Card.Body>
                    <Flex space="between" vAlign="center">
                      <Button
                        content={t("Promotions.Start")}
                        primary
                        onClick={() =>
                          RedirectoSearchPage(
                            promotion.id,
                            promotion.budgetInfo,
                            promotion
                          )
                        }
                      />
                    </Flex>
                  </Card.Body>
                </Card.Column>
                {promotion.awardAvailable && promotion.budgetInfo !== null && (
                  <Card.Column className="promoFooter">
                    <Flex space="between" vAlign="center">
                      <Text
                        className="bit_text_14 bit_space5"
                        weight="bold"
                        content={promotion.budgetInfo.currentValue.toLocaleString()}
                      />
                      <Text
                        className="bit_tinyText"
                        content={t("Promotions.PointsRemaining")}
                      />
                    </Flex>
                    <Flex space="between" vAlign="center">
                      <Text
                        className={
                          promotion.budgetInfo.daysRemaining >= 0
                            ? t("Promotions.RemainingDays")
                            : t("Promotions.RemainingDaysEmpty")
                        }
                        content={getRemainingDays(
                          promotion.budgetInfo.daysRemaining
                        )}
                      />
                    </Flex>
                  </Card.Column>
                )}
                {promotion.badgeDetails &&
                  promotion.badgeDetails.length > 0 && (
                    <Slider
                      image={promotion.badgeDetails[0].img}
                      defaultValue={promotion.badgeDetails[0].progressNumerator}
                      max={promotion.badgeDetails[0].progressDenominator}
                      title={promotion.badgeDetails[0].name}
                    />
                  )}
              </Card>
            ))}
        </Flex>
      </Provider>
    </AppCtx.Provider>
  ) : (
    <div className="align-center">
      <LoaderExample />
    </div>
  );
};
